const routes = [
  // echo
  {
    path: "/docs/iOS/privacy-protocol",
    name: "EchoPrivacyProtocol",
    component: () =>
      import(
        "@/views/P3_Page/Docs/iOS/PrivacyPolicy.vue"
      )
  },
  {
    path: "/docs/iOS/user-protocol",
    name: "EchoPrivacyProtocol",
    component: () =>
      import(
        "@/views/P3_Page/Docs/iOS/UserProtocol"
      )
  },
  // kiko
  {
    path: "/docs/kiko/privacy-protocol",
    name: "KikoPrivacyProtocol",
    component: () =>
      import(
        "@/views/P3_Page/Docs/kiko/PrivacyPolicy.vue"
      )
  },
  {
    path: "/docs/kiko/user-protocol",
    name: "KikoPrivacyProtocol",
    component: () =>
      import(
        "@/views/P3_Page/Docs/kiko/UserProtocol"
      )
  }
];
export default routes;
